import { createV3Queries } from "@query/utils/createV3Queries";
import { currencyApi } from "@api";

export const queriesCurrency = createV3Queries("currencyApi", currencyApi);
